import { render, staticRenderFns } from "./InboxHome.vue?vue&type=template&id=7e6f2f55&scoped=true"
import script from "./InboxHome.vue?vue&type=script&lang=js"
export * from "./InboxHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6f2f55",
  null
  
)

export default component.exports